import { createAction } from '@ngrx/store';

export const loaded = createAction(
  '[Home Page] Loaded'
);
